<app-bar-chart
  [labels]="labels"
  [series]="series"
  [entityLabels]="entities"
  [loading]="isLoading"
  [title]="'Thumbs Per Entity'"
  [stacked]="true"
  [options]="this.options"
  [translateLabels]="true"
></app-bar-chart>
